export default "__VITE_ASSET__1aebf345__"